<template>
  <div class="d-flex justify-content-center">
    <div class="card card-profile w-100 mb-4" v-if="personalInfo">
      <div class="card-header">Profil</div>
      <div class="card-body p-4 p-md-5">
        <div class="row">

          <div class="col-12 col-md-6">
            <div v-if="personalInfo.person_type_id === 1">
              <div class="my-1 color-yellow"><b>Vaše osobné údaje</b></div>
              <div v-for="(item, i) in schema.personal" :key="i" class="row">
                <div class="col-12 col-md-6">{{ item.label }}:</div>
                <div
                  v-if="item.type === 'date'"
                  class="color-medium-gray col-12 col-md-6"
                >
                  {{ personalInfo[i] | date }}
                </div>
                <span v-else class="color-medium-gray col-12 col-md-6">
                  {{ personalInfo[i] }}
                </span>
              </div>
            </div>

            <div v-if="personalInfo.person_type_id === 2">
              <div class="my-1 color-yellow"><b>Údaje o spoločnosti</b></div>
              <div v-for="(item, i) in schema.company" :key="i" class="row">
                <div class="col-12 col-md-6">{{ item.label }}:</div>
                <div class="color-medium-gray col-12 col-md-6">
                  {{ personalInfo[i] }}
                </div>
              </div>
            </div>

            <div v-if="personalInfo.person_type_id === 3">
              <div class="my-1 color-yellow"><b>Údaje o dieťati</b></div>
              <div v-for="(item, i) in schema.child" :key="i" class="row">
                <div class="col-12 col-md-6">{{ item.label }}:</div>
                <div class="color-medium-gray col-12 col-md-6">
                  {{ personalInfo[i] }}
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-6">
            <div class="mb-1 color-yellow"><b>Adresa</b></div>
            <div v-for="(item, i) in schema.address" :key="i" class="row">
              <div class="col-12 col-md-5">{{ item.label }}:</div>
              <div class="color-medium-gray col-12 col-md-7">
                {{ personalInfo[i] }}
              </div>
            </div>

            <div class="mt-4 mb-1 color-yellow"><b>Kontaktné údaje</b></div>
            <div v-for="(item, i) in schema.contact" :key="i" class="row">
              <div class="col-12 col-md-5">{{ item.label }}:</div>
              <div class="color-medium-gray col-12 col-md-7">
                {{ personalInfo[i] }}
              </div>
            </div>
          </div>
        </div>

        <div v-if="personalInfo.representatives.length > 0">
          <hr class="my-4 card-divider">
          <div class="row">
            <div class="col-12">
              <div class="mb-1 color-yellow"><b>Oprávnená osoba</b></div>
              <div v-for="(item, i) in schema.representative" :key="i" class="row">
                <div class="col-12 col-md-3">{{ item.label }}:</div>
                <div
                  v-if="item.type === 'date'"
                  class="color-medium-gray col-12 col-md-6"
                >
                  {{ personalInfo.representatives[0][i] | date }}
                </div>
                <div v-else class="color-medium-gray col-12 col-md-9">
                  {{ personalInfo.representatives[0][i] }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <hr class="my-4 card-divider">

        <div class="row" v-if="personalInfo.person_type_id === 1">
          <div class="col-12 col-lg-11 text-right">
            <button
              type="button"
              class="btn btn-warning mr-0 mb-2"
              @click="openedChangePersonalInfoModal = true"
            >
              <span class="mx-2">Aktualizovať údaje</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      size="xl"
      title="Zmena osobných údajov"
      v-model="openedChangePersonalInfoModal"
      modal-footer
    >
      <change-personal-info @changed="openedChangePersonalInfoModal = false" />
      <template v-slot:modal-footer><div></div></template>
    </b-modal>
  </div>
</template>

<script>
import ChangePersonalInfo from "@/components/form/ChangePersonalInfo";
import Loading from "../../../components/Loading";

export default {
  name: "Profile",
  components: {
    ChangePersonalInfo
  },
  computed: {
    loading() {
      return this.$store.state.account.loading;
    },
    personalInfo() {
      return this.$store.state.account.profileInfo;
    }
    // assignedToSomeone() {
    //   return this.$store.state.account.assignedToSomeone;
    // }
  },
  data() {
    return {
      openedChangePersonalInfoModal: false,
      schema: {
        personal: {
          academic_title_before: {
            label: "Titul",
            type: "string"
          },
          name: {
            label: "Meno",
            type: "string"
          },
          surname: {
            label: "Priezvisko",
            type: "string"
          },
          academic_title_after: {
            label: "Titul za menom",
            type: "string"
          },
          birthday: {
            label: "Dátum narodenia",
            type: "date"
          },
          birthnumber: {
            label: "Rodné číslo",
            type: "string"
          },
          nationality: {
            label: "Štátna príslušnosť",
            type: "string"
          },
          idcard_no: {
            label: "Číslo preukazu totožnosti",
            type: "string"
          },
          idcard_validity: {
            label: "Platnosť preukazu totožnosti",
            type: "date"
          }
        },
        company: {
          company_name: {
            label: "Názov spoločnosti",
            type: "string"
          },
          company_idno: {
            label: "IČO",
            type: "string"
          },
          company_vat: {
            label: "DIČ",
            type: "string"
          }
        },
        child: {
          name: {
            label: "Meno",
            type: "string"
          },
          surname: {
            label: "Priezvisko",
            type: "string"
          },
          birthdate: {
            label: "Dátum narodenia",
            type: "string"
          },
          birthnumber: {
            label: "Rodné číslo",
            type: "string"
          },
          nationality: {
            label: "Štátna príslušnosť",
            type: "string"
          }
        },
        address: {
          street: {
            label: "Ulica",
            type: "string"
          },
          city: {
            label: "Mesto",
            type: "string"
          },
          zip: {
            label: "PSČ",
            type: "string"
          }
        },
        contact: {
          email: {
            label: "Email",
            type: "string"
          },
          phone: {
            label: "Telefónne číslo",
            type: "string"
          }
        },
        bankAccount: {
          bank_account_owner_name: {
            label: "Názov účtu",
            type: "string"
          },
          iban: {
            label: "IBAN",
            type: "string"
          },
          swift: {
            label: "SWIFT kód",
            type: "string"
          },
          currency: {
            label: "Mena účtu",
            type: "string"
          }
        },
        representative: {
          name: {
            label: "Meno",
            type: "string"
          },
          surname: {
            label: "Priezvisko",
            type: "string"
          },
          addressShort: {
            label: "Adresa",
            type: "string"
          },
          birthnumber: {
            label: "Rodné číslo",
            type: "string"
          // },
          // nationality: {
          //   label: "Štátna príslušnosť",
          //   type: "string"
          }
        }
      }
    };
  }
};
</script>

<style lang="scss" scoped>

.card-profile {
  //max-width: 1000px;

  .btn-edit {
    font-size: 12px;
    line-height: 12px;
  }

  .address-checkbox {
    font-size: 13px;
  }

  .profile-wrapper {
    font-size: 13px;

    > .row {
      margin-top: 15px;

      > div:first-child {
        text-align: right;
        color: #9a9a9a;

        strong {
          color: #fff;
        }
      }
    }
  }

  @include media-breakpoint-down(md) {
    .card-body {
      padding-left: 10px;
      padding-right: 10px;
    }
  }
}
</style>
